export default __webpack_public_path__ + "static/media/EAST1070.34I-34197_-18442_0.d4105b79.jpg";